import _ from 'lodash';
import { isMixpanelDNT, mixpanel, notifyMixpanelIdentified, setMixpanelGroup, startSessionReplay, } from './mixpanel-service';
export var PeoplePropertiesEnum;
(function (PeoplePropertiesEnum) {
    PeoplePropertiesEnum["userGUID"] = "userGUID";
    PeoplePropertiesEnum["firstLogin"] = "firstLogin";
    PeoplePropertiesEnum["initialReferrer"] = "initialReferrer";
    PeoplePropertiesEnum["firstUtmMedium"] = "firstUtmMedium";
    PeoplePropertiesEnum["firstUtmSource"] = "firstUtmSource";
    PeoplePropertiesEnum["clusterId"] = "clusterId";
    PeoplePropertiesEnum["clusterName"] = "clusterName";
    PeoplePropertiesEnum["userLocale"] = "userLocale";
    PeoplePropertiesEnum["releaseVersion"] = "releaseVersion";
    PeoplePropertiesEnum["blinkReleaseVersion"] = "blinkReleaseVersion";
    PeoplePropertiesEnum["usedEmbedded"] = "usedEmbedded";
    PeoplePropertiesEnum["isAdminUser"] = "isAdminUser";
    PeoplePropertiesEnum["firstSearch"] = "firstSearch";
    PeoplePropertiesEnum["firstPin"] = "firstPin";
    PeoplePropertiesEnum["firstPinboardCreation"] = "firstPinboardCreation";
    PeoplePropertiesEnum["privileges"] = "privileges";
    PeoplePropertiesEnum["userPersona"] = "userPersona";
    PeoplePropertiesEnum["teamOwner"] = "teamOwner";
    PeoplePropertiesEnum["userOrgs"] = "userOrgs";
    PeoplePropertiesEnum["tsRef"] = "tsRef";
    PeoplePropertiesEnum["onboardingFlowSelected"] = "onboardingFlowSelected";
})(PeoplePropertiesEnum || (PeoplePropertiesEnum = {}));
export var PeopleIncrementalPropertiesEnum;
(function (PeopleIncrementalPropertiesEnum) {
    PeopleIncrementalPropertiesEnum["totalLogin"] = "totalLogin";
    PeopleIncrementalPropertiesEnum["totalAnswerViews"] = "totalAnswerViews";
    PeopleIncrementalPropertiesEnum["totalPinboardViews"] = "totalPinboardViews";
    PeopleIncrementalPropertiesEnum["totalSpotIQPinboardViews"] = "totalSpotIQPinboardViews";
    PeopleIncrementalPropertiesEnum["totalSageSearches"] = "totalSageSearches";
    PeopleIncrementalPropertiesEnum["totalPins"] = "totalPins";
    PeopleIncrementalPropertiesEnum["totalPinboardShares"] = "totalPinboardShares";
    PeopleIncrementalPropertiesEnum["totalAnswerShares"] = "totalAnswerShares";
    PeopleIncrementalPropertiesEnum["totalPinboardLinks"] = "totalPinboardLinks";
    PeopleIncrementalPropertiesEnum["totalAnswerLinks"] = "totalAnswerLinks";
    PeopleIncrementalPropertiesEnum["totalDataViews"] = "totalDataViews";
    PeopleIncrementalPropertiesEnum["totalAdminViews"] = "totalAdminViews";
    PeopleIncrementalPropertiesEnum["totalPinboardSubscribed"] = "totalPinboardSubscribed";
    PeopleIncrementalPropertiesEnum["totalEmailsAdded"] = "totalEmailsAdded";
    PeopleIncrementalPropertiesEnum["totalProfilePasswordChanged"] = "totalProfilePasswordChanged";
    PeopleIncrementalPropertiesEnum["totalProfilePicUpdated"] = "totalProfilePicUpdated";
    PeopleIncrementalPropertiesEnum["totalShareVizEmail"] = "totalShareVizEmail";
    PeopleIncrementalPropertiesEnum["totalSearchAssistLessonsStarted"] = "totalSearchAssistLessonsStarted";
    PeopleIncrementalPropertiesEnum["totalSearchAssistLessonsEnded"] = "totalSearchAssistLessonsEnded";
    PeopleIncrementalPropertiesEnum["totalTrialExpiryBtnCLicks"] = "totalTrialExpiryBtnCLicks";
})(PeopleIncrementalPropertiesEnum || (PeopleIncrementalPropertiesEnum = {}));
export var PeopleSetPropertiesEnum;
(function (PeopleSetPropertiesEnum) {
    PeopleSetPropertiesEnum["lastLogin"] = "lastLogin";
    PeopleSetPropertiesEnum["lastPinboardUsage"] = "lastPinboardUsage";
    PeopleSetPropertiesEnum["lastAnswerPageUsage"] = "lastAnswerPageUsage";
    PeopleSetPropertiesEnum["lastSearchIQUsage"] = "lastSearchIQUsage";
    PeopleSetPropertiesEnum["lastAdminUsage"] = "lastAdminUsage";
    PeopleSetPropertiesEnum["lastSpotIQUsage"] = "lastSpotIQUsage";
    PeopleSetPropertiesEnum["lastDataUsage"] = "lastDataUsage";
    PeopleSetPropertiesEnum["lastPageVisited"] = "lastPageVisited";
    PeopleSetPropertiesEnum["hasEmail"] = "hasEmail";
    PeopleSetPropertiesEnum["$email"] = "$email";
    PeopleSetPropertiesEnum["onboardingFlowSelected"] = "onboardingFlowSelected";
})(PeopleSetPropertiesEnum || (PeopleSetPropertiesEnum = {}));
export var PeoplePropertiesTypeEnum;
(function (PeoplePropertiesTypeEnum) {
    PeoplePropertiesTypeEnum["peoplePropsForSet"] = "peoplePropsForSet";
    PeoplePropertiesTypeEnum["peoplePropsForSetOnce"] = "peoplePropsForSetOnce";
    PeoplePropertiesTypeEnum["peoplePropsForUnion"] = "peoplePropsForUnion";
    PeoplePropertiesTypeEnum["peoplePropForIncrement"] = "peoplePropForIncrement";
})(PeoplePropertiesTypeEnum || (PeoplePropertiesTypeEnum = {}));
let sessionDefaultsPeopleProps = {};
let mixpanelPeoplePropsOpts;
export const init = async (opts) => {
    mixpanelPeoplePropsOpts = opts;
    await setPeopleProperties(opts.userGuid);
    await postPropsToMixpanel(opts.userGuid, opts.isAnonymousUser, opts.teamId);
};
export const updatePeopleProperty = (PropName, newValue) => {
    if (isMixpanelDNT() || !_.keys(sessionDefaultsPeopleProps).length) {
        return;
    }
    const PeoplePropType = getPeoplePropType(PropName);
    if (_.isEmpty(PeoplePropType)) {
        return;
    }
    updateProperty(PeoplePropType, PropName, newValue);
};
export const getPeoplePropsForSet = () => {
    const peopleProps = {};
    peopleProps[PeopleSetPropertiesEnum.lastLogin] = new Date().toISOString().slice(0, 10);
    peopleProps[PeopleSetPropertiesEnum.hasEmail] = !!mixpanelPeoplePropsOpts.userEmail;
    peopleProps[PeopleSetPropertiesEnum.$email] =
        mixpanelPeoplePropsOpts.userEmail;
    peopleProps[PeoplePropertiesEnum.userPersona] =
        mixpanelPeoplePropsOpts.userPersona;
    return peopleProps;
};
export const getPeoplePropsForSetOnce = (userGUID) => {
    const peopleProps = { userGUID };
    peopleProps[PeoplePropertiesEnum.initialReferrer] = mixpanelPeoplePropsOpts.getPath();
    if (mixpanelPeoplePropsOpts.isFirstLogin) {
        peopleProps[PeoplePropertiesEnum.firstUtmMedium] =
            mixpanelPeoplePropsOpts.firstUtmMedium;
        peopleProps[PeoplePropertiesEnum.firstUtmSource] =
            mixpanelPeoplePropsOpts.firstUtmSource;
    }
    peopleProps[PeoplePropertiesEnum.isAdminUser] =
        mixpanelPeoplePropsOpts.hasAdminPrivileges;
    peopleProps[PeoplePropertiesEnum.teamOwner] =
        mixpanelPeoplePropsOpts.teamOwner;
    return peopleProps;
};
export const getPeoplePropsForUnion = async () => {
    const peopleProps = {};
    const version = mixpanelPeoplePropsOpts.releaseVersion;
    peopleProps[PeoplePropertiesEnum.clusterId] =
        mixpanelPeoplePropsOpts.clusterId;
    peopleProps[PeoplePropertiesEnum.clusterName] =
        mixpanelPeoplePropsOpts.clusterName;
    peopleProps[PeoplePropertiesEnum.releaseVersion] = version || [''];
    peopleProps[PeoplePropertiesEnum.blinkReleaseVersion] = mixpanelPeoplePropsOpts.blinkReleaseVersion || version || [''];
    peopleProps[PeoplePropertiesEnum.userLocale] =
        mixpanelPeoplePropsOpts.preferredLocale;
    peopleProps[PeoplePropertiesEnum.usedEmbedded] =
        mixpanelPeoplePropsOpts.isEmbedded;
    peopleProps[PeoplePropertiesEnum.privileges] =
        mixpanelPeoplePropsOpts.userPrivileges;
    peopleProps[PeoplePropertiesEnum.userOrgs] =
        mixpanelPeoplePropsOpts.userOrgs;
    return peopleProps;
};
export const getPeopleProperties = () => {
    return sessionDefaultsPeopleProps;
};
const updateProperty = (PeoplePropType, PeoplePropName, newValue) => {
    const peopleProperties = sessionDefaultsPeopleProps[PeoplePropType];
    switch (PeoplePropType) {
        case PeoplePropertiesTypeEnum.peoplePropsForSet:
            if (peopleProperties[PeoplePropName] !== newValue) {
                peopleProperties[PeoplePropName] = newValue;
                mixpanel.people.set({ [PeoplePropName]: newValue });
            }
            break;
        case PeoplePropertiesTypeEnum.peoplePropsForUnion:
            const currentVal = peopleProperties[PeoplePropName];
            currentVal.push(newValue);
            mixpanel.people.union({ [PeoplePropName]: currentVal });
            break;
        case PeoplePropertiesTypeEnum.peoplePropForIncrement:
            mixpanel.people.increment(PeoplePropName);
            break;
    }
};
const setPeopleProperties = async (userGUID) => {
    const peoplePropsForSet = getPeoplePropsForSet();
    const peoplePropsForSetOnce = getPeoplePropsForSetOnce(userGUID);
    const peoplePropsForUnion = await getPeoplePropsForUnion();
    const peoplePropForIncrement = PeopleIncrementalPropertiesEnum.totalLogin;
    sessionDefaultsPeopleProps = {
        peoplePropsForSet,
        peoplePropsForSetOnce,
        peoplePropsForUnion,
        peoplePropForIncrement,
    };
};
const postPropsToMixpanel = async (userGUID, isAnonymousUser, teamId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    mixpanel.people.set(sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForSet]);
    if (!isAnonymousUser) {
        mixpanel.identify(userGUID);
        startSessionReplay();
        setMixpanelGroup('teamId', teamId);
    }
    notifyMixpanelIdentified();
    mixpanel.people.set_once(sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForSetOnce]);
    mixpanel.people.union(sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForUnion]);
    mixpanel.people.increment(sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropForIncrement]);
    (_c = (_a = mixpanel
        .get_group) === null || _a === void 0 ? void 0 : _a.call(mixpanel, 'clusterId', (_b = mixpanelPeoplePropsOpts.clusterId) === null || _b === void 0 ? void 0 : _b[0])) === null || _c === void 0 ? void 0 : _c.set({
        clusterName: (_d = mixpanelPeoplePropsOpts.clusterName) === null || _d === void 0 ? void 0 : _d[0],
        releaseVersion: (_e = mixpanelPeoplePropsOpts.releaseVersion) === null || _e === void 0 ? void 0 : _e[0],
        lastLogin: sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForSet][PeopleSetPropertiesEnum.lastLogin],
    });
    if (mixpanelPeoplePropsOpts.isTeamsEnabled) {
        if (mixpanelPeoplePropsOpts.teamOwner) {
            (_g = (_f = mixpanel
                .get_group) === null || _f === void 0 ? void 0 : _f.call(mixpanel, 'teamId', mixpanelPeoplePropsOpts.teamId)) === null || _g === void 0 ? void 0 : _g.set_once({
                ownerGuid: mixpanelPeoplePropsOpts.userGuid,
            });
        }
        (_j = (_h = mixpanel.get_group) === null || _h === void 0 ? void 0 : _h.call(mixpanel, 'teamId', mixpanelPeoplePropsOpts.teamId)) === null || _j === void 0 ? void 0 : _j.set({
            clusterId: (_k = mixpanelPeoplePropsOpts.clusterId) === null || _k === void 0 ? void 0 : _k[0],
            clusterName: (_l = mixpanelPeoplePropsOpts.clusterName) === null || _l === void 0 ? void 0 : _l[0],
            releaseVersion: (_m = mixpanelPeoplePropsOpts.releaseVersion) === null || _m === void 0 ? void 0 : _m[0],
            lastLogin: sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForSet][PeopleSetPropertiesEnum.lastLogin],
        });
    }
    const firstLoginDate = mixpanelPeoplePropsOpts.firstLoginDate;
    if (firstLoginDate && firstLoginDate !== 0) {
        const setFirstLoginDate = {};
        setFirstLoginDate[PeoplePropertiesEnum.firstLogin] = new Date(firstLoginDate);
        mixpanel.people.set_once(setFirstLoginDate);
    }
};
const getPeoplePropType = (PropName) => {
    if (!sessionDefaultsPeopleProps) {
        return '';
    }
    const incrementalProps = _.keys(PeopleIncrementalPropertiesEnum);
    const setProperties = _.keys(PeopleSetPropertiesEnum);
    if (_.includes(setProperties, PropName)) {
        return PeoplePropertiesTypeEnum.peoplePropsForSet;
    }
    if (sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForSetOnce].hasOwnProperty(PropName)) {
        return PeoplePropertiesTypeEnum.peoplePropsForSetOnce;
    }
    if (sessionDefaultsPeopleProps[PeoplePropertiesTypeEnum.peoplePropsForUnion].hasOwnProperty(PropName)) {
        return PeoplePropertiesTypeEnum.peoplePropsForUnion;
    }
    if (_.includes(incrementalProps, PropName)) {
        return PeoplePropertiesTypeEnum.peoplePropForIncrement;
    }
    return '';
};
//# sourceMappingURL=mixpanel-people-properties.js.map